module.exports = __webpack_public_path__ + "img/h200.1947c2ca.jpg";